import React, { Fragment } from 'react';
import { AppGridLayout, AppTableSearch, AppSearchItem, AppTable, AppRow, AppButton, AppGridTabs } from 'qcc';
import { AppAction, AppGridBar, SearchEnum } from 'qcc';
import api, { PosAppTradeOutput, PosSAPStkInput } from "api";
import { appNumber, appDate } from "utils";
import './index.less'
import SetBillTemplateForm from './SetBillTemplateForm'
import { PageOptions, indexTable, pageAction } from './indexData'

export default class extends React.Component {

  tabList = ['有效单据', '已撤销单据']
  state = { currTab: 0 }

  chgTab = (index: number) => {
    // console.log(index)
    this.setState({ currTab: index })
  }



  componentDidMount() {
    pageAction.setRefGrid(this.refGrid.current)
  }


  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
  }

  doRefresh = async () => {
    if (this.refGrid.current) {
      AppAction.coverFull();
      await this.refGrid.current.state.refTable.fetch();
      AppAction.cancelCoverFull();
    }
  }


  doExport = async () => {

    AppAction.coverFull();
    let appTableQuery = this.refGrid.current.state.refTable.getAppTableQuery();
    let downloadUrl;
    let fileName;
    if (this.state.currTab === 0) {
      fileName = '收款单据-有效明细';
      downloadUrl = await api.posgetinfee.exportValidBillList(appTableQuery);
    } else {
      fileName = '收款单据-已撤销单据';
      downloadUrl = await api.posgetinfee.exportRevokedBillList(appTableQuery);
    }
    window.location.href = `/api/public/download?filePath=${downloadUrl}&fileName=` + fileName + `.xlsx`;
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.cancelCoverFull();
  }


  refGrid = React.createRef<AppGridLayout>();

  render() {
    return (
      <AppGridLayout ref={this.refGrid} key={this.state.currTab}>
        <AppGridLayout.SearchArea>
          <AppTableSearch>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
              <AppSearchItem.SearchInput placeholder='请录入姓名/手机号/证件号' keyName='common'
                field='customer_name,tell,id_number' />
            </AppTableSearch.Common>
            <AppTableSearch.Advanced>
              <AppSearchItem.Advanced
                lable='收款日期:'
                keyName='getDate'
                field='get_date'
                itemType={SearchEnum.itemType.dateRange}
              />
              <AppSearchItem.Advanced
                lable='电子收据:'
                keyName='networkStatusName'
                field='web_bill_status_name'
                itemType={SearchEnum.itemType.multCheck} options={PageOptions.WebBillStatus} />
              <AppSearchItem.Advanced
                lable='购房人:'
                keyName='buyerName'
                field='buyer_name'
                itemType={SearchEnum.itemType.text}
              />
              <AppSearchItem.Advanced
                lable='监管账号:'
                keyName='regulatoryAccount'
                field='regulatory_account'
                itemType={SearchEnum.itemType.text}
              />
              <AppSearchItem.Advanced
                lable='监管子账号:'
                keyName='subRegulatoryAccount'
                field='sub_regulatory_account'
                itemType={SearchEnum.itemType.text}
              />
              <AppSearchItem.Advanced
                lable='住建局缴费单号:'
                keyName='zjjBillNo'
                field='zjj_bill_no'
                itemType={SearchEnum.itemType.text}
              />
              <AppSearchItem.Advanced
                lable='实收款:'
                keyName='syncStatusName'
                field={this.state.currTab === 0 ? 'sync_status_name' : 'sync_cancel_status_name'}
                itemType={SearchEnum.itemType.multCheck} options={PageOptions.SyncStatus} />
            </AppTableSearch.Advanced>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Left>
              <AppGridTabs tabs={this.tabList} defaultTabIndex={this.state.currTab} befChange={() => true} onChange={index => this.chgTab(index)} />
            </AppGridBar.Left>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='生成电子票据' actionCode="66101001" type='primary' action={pageAction.generateBill} />
                <AppButton label='导出' actionCode="66101098" action={() => this.doExport()} />
                <AppButton label='刷新' action={() => this.doRefresh()} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea >
          {indexTable[this.state.currTab]}
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/getin/index.tsx